<div class="sub-content">
  <div class="icon-container">
    <sui-icon name="부록"></sui-icon>
  </div>
  <span>부록</span>
</div>
